<template>
  <nav @click="expandWalletAddress = false">
    <router-link to="/mint">Mint</router-link> |
    <router-link to="/my-reapers">My NFTs</router-link> |
    <router-link to="/all-reapers">Explore Collection</router-link>
    |
    <router-link to="/">SVC Cards Game</router-link>
    |
    <router-link to="/info">Staking and Leveling Info</router-link> |
    <router-link to="/tokenomics">SVC Tokenomics</router-link> |
    <a
      @click.stop="expandWalletAddress = !expandWalletAddress"
      v-if="stakersAddressShort !== null"
    >
      {{ stakersAddressShort }}
      <i v-if="expandWalletAddress === false" class="ri-arrow-down-s-line"></i>
      <i v-else class="ri-arrow-up-s-line"></i>
    </a>
    <a v-else @click="loginMM()"> Login </a>
  </nav>

  <div
    @click="expandWalletAddress = false"
    class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12"
    v-if="expandWalletAddress"
  >
    <div class="card-body mt-0 mb-4">
      <hr class="mt-0 mb-0" />
      <a
        class="dropdown-item"
        :href="'https://oasis.cash/collection/' + address['reaper']"
        target="_blank"
      >
        Buy or Sell Reaperville NFTs on Oasis
      </a>

      <a
        class="dropdown-item mt-0"
        href="https://app.mistswap.fi/swap?inputCurrency=BCH&outputCurrency=0xE7B1076d0853a7aAa6FbB477886726ed03C6Fffd"
        target="_blank"
      >
        Trade SVC on MistSwap
      </a>

      <a
        class="dropdown-item"
        href="https://dexscreener.com/smartbch/0x83c337dc968fde2ed1b8347768d9970f7a925be7"
        target="_blank"
      >
        Check the SVC price on Dexscreener
      </a>

      <a class="dropdown-item" href="https://ville.cash/" target="_blank">
        Surviville Homepage
      </a>

      <a
        class="dropdown-item"
        href="https://ville.cash/roadmap/"
        target="_blank"
      >
        Surviville Roadmap
      </a>

      <a class="dropdown-item" href="https://t.me/reaperville" target="_blank">
        Talk to us on Telegram
      </a>

      <a
        class="dropdown-item"
        href="https://twitter.com/SurvivilleCoin"
        target="_blank"
      >
        Follow us on Twitter
      </a>

      <a
        class="dropdown-item"
        v-bind:href="'https://www.smartscan.cash/address/' + address['reaper']"
        target="_blank"
      >
        Inspect Reaperville Contract Activity
      </a>

      <a
        class="dropdown-item"
        v-bind:href="'https://www.smartscan.cash/address/' + address['svc']"
        target="_blank"
      >
        Inspect SVC Contract Activity
      </a>

      <span @click="addRewardTokenToMM" class="dropdown-item">
        Add Surviville Coin (SVC) to Metamask
      </span>
      <hr class="mt-0 mb-0" />
    </div>
  </div>

  <h4
    v-if="wrongNetwork"
    @click="
      expandWalletAddress = false;
      addNetwork();
    "
    class="animate-characters"
  >
    <hr class="my-4" />
    <strong>Please switch the network to {{ netName }}.</strong>
    <hr class="my-4" />
  </h4>

  <div @click="expandWalletAddress = false">
    <router-view />
  </div>
</template>

<script>
import { ethers } from "ethers";
export default {
  data() {
    return {
      stakersAddressShort: null,

      signer: null,
      provider: null,

      expandWalletAddress: false,

      address: {},

      netName: window.netName,
      wrongNetwork: false,
    };
  },

  mounted: function () {
    this.address["reaper"] = window.ca["reaper"];
    this.address["svc"] = window.ca["svc"];

    this.provider = new ethers.providers.Web3Provider(window.ethereum, "any");

    this.provider.getNetwork().then((network) => {
      if (network.chainId !== window.netId) {
        this.wrongNetwork = true;
        window.ethereum
          .request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: window.netId0x }],
          })
          .catch((err) => {
            // This error code indicates that the chain has not been added to MetaMask
            if (err.code === 4902) {
              this.addNetwork();
            }
          });
      }
    });
    this.provider.on("network", (n, o) => {
      if (o) {
        window.location.reload();
      }
    });
    this.signer = this.provider.getSigner();
    this.signer.getAddress().then((address) => {
      this.stakersAddressShort =
        address.substring(0, 4) +
        "..." +
        address.substring(address.length - 4, address.length);
    });
  },
  methods: {
    loginMM: function () {
      window.location.reload();
    },

    addNetwork: function () {
      window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainName: window.netName,
            chainId: window.netId0x,
            nativeCurrency: {
              name: window.ETH,
              decimals: 18,
              symbol: window.ETH,
            },
            rpcUrls: [window.rpcServer],
            blockExplorerUrls: [window.blockExplorer],
          },
        ],
      });
    },

    addRewardTokenToMM: function () {
      window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: window.ca["svc"],
            symbol: "SVC",
            decimals: 18,
          },
        },
      });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #6ca1e3;
  background-color: #131129;
}

.animate-characters {
  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #e2da02 8%,
    #ff1361 26%,
    #1438da 42%,
    #6310bc 58%,
    #ff1361 74%,
    #e2da02 90%
  );
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 15s ease-in-out infinite;
  display: inline-block;
}

.animate-popup {
  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #fbff00 0%,
    #ff0055 50%,
    #fbff00 75%
  );
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 5s linear infinite;
  display: inline-block;
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}

table,
th,
td {
  border: 2px solid 131129;
  border-collapse: collapse;
}
th,
td {
  background-color: #39186d;
}

.card {
  background-color: #31073e;
  padding: 0px 0px;
  border: 1.5px solid rgb(0 0 0);
  border-radius: 0.25rem;
}

.card-selected {
  background-color: rgba(9, 198, 240, 0.4);
  padding: 1.1rem 1.1rem;
  border: 1.5px solid rgb(9, 198, 240);
  border-radius: 0.25rem;
  box-shadow: 0 0 20px rgb(70, 193, 221), 0 0 50px rgba(9, 198, 240, 0.4);
}

.popup {
  background-color: #342e76;
  opacity: 0.9;
  margin-top: 2;
  margin-bottom: 2;
  padding: 20px;
  color: rgba(246, 23, 216, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 0 10px #c65ef6, 0 0 20px #dd93ff94;
}
.popupX {
  color: rgba(168, 18, 148, 0.9);
  font-size: 20px;
  position: fixed;
  top: 5px;
  right: 30px;
}
.popupX:hover {
  color: rgb(255, 0, 221);
  transform: scale(1.5);
}

.dropdown-menu a {
  border-color: hsla(296, 92%, 47%, 0.77);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  color: #aecaeb;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: #39186d;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  color: #aecaeb;
  background-color: rgb(131, 31, 154);
  border-color: #8705a4;
}

.btn-std {
  color: #aecaeb;
  background-color: rgb(131, 31, 154);
  border-color: #8705a4;
}

.btn-sm:focus,
.btn-std:focus {
  outline: 0;
  color: #aecaeb;
  background-color: rgb(131, 31, 154);
  border-color: #8705a4;
}

.btn-sm:active,
.btn-sm.on,
.btn-std:active,
.btn-std.on {
  color: #aecaeb;
  background-color: rgb(131, 31, 154);
  border-color: #8705a4;
  box-shadow: 0 0 10px #c65ef6, 0 0 20px #dd93ff94;
}

.btn-sm:disabled,
.btn-std:disabled {
  color: #aecaeb;
  background-color: #77547e;
  border-color: #9459a2;
}

.btn-sm:not([disabled]):hover,
.btn-std:not([disabled]):hover {
  color: rgb(6, 6, 6);
  background-color: #c65ef6;
  border-color: transparent;
}

.btn-outline-std {
  color: #aecaeb;
  background-color: transparent;
  background-image: none;
  border: 3px solid;
  border-color: #8705a4;
}

.btn-outline-std:hover {
  color: rgb(6, 6, 6);
  background-color: #c65ef669;
  border-color: transparent;
}

.btn-outline-secondary {
  color: #aecaeb;
  background-color: #f48a1972;
}

.btn-outline-secondary:hover {
  color: #aecaeb;
  background-color: #c46b0be5;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #3e5771;
}

nav a.router-link-exact-active {
  color: #7242b9;
}

a {
  color: #992cd4;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}

a:hover {
  color: #c65ef6;
  -webkit-text-decoration-skip: objects;
}

a:not([href]):not([id]):not([tabindex]) {
  color: #3e5771;
  text-decoration: none;
}

a:not([href]):not([id]):not([tabindex]):hover {
  color: #c65ef6;
  text-decoration: underline;
}

.dropdown-item:hover {
  background-color: #c65ef6;
  -webkit-text-decoration-skip: objects;
  box-shadow: 0 0 5px #c65ef6, 0 0 10px #dd93ff94;
}

hr {
  border-top: 2px solid rgb(147 7 238 / 85%);
  box-shadow: 0 0 5px #c65ef6, 0 0 10px #dd93ff94;
}
</style>
